<!--抄表系统首页-->
<template>
	<div style="padding: 0 10px 10px 10px;height: calc(100% - 10px);">
		<datePicker ref="datePicker" :initDate='nowSelectDate' type="day" @selectDate="selectDate"></datePicker>
		<div class="detailsTop">
			<iconButton icoName="wedoButton/point_left.png" buttonText="返回列表" @buttonClick="closeDetails"
				style="margin-top: 10px;"></iconButton>
		</div>
		<div class="flexBetween" style="height: calc(50% - 40px);">
			<div class="meterDetailLeft">
				<div class="areaContainer">
					<p class="areaTitle">电表信息
						<span class="ownerAddress">编号：{{editText(item.deviceNo)}}</span>
						&ensp;
						<span class="ownerInfoStatus" style="color: #00CC66" v-show="item.deviceState == 1">在线</span>
						<span class="ownerInfoStatus" style="color: red" v-show="item.deviceState != 1">离线</span>
					</p>
					<div class="areaContentHeight" style="display: flex;flex-direction: column;justify-content: space-around;">
						<div class="flexAround">
							<div class="houseInfoLi">
								<div class="iconMeterDetail" style="background-color: #CCCCCC;">
									<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')"
										alt="" />
								</div>
								<p>设备名称</p>
								<h2><span>{{editText(item.deviceName)}}</span></h2>
							</div>

							<div class="houseInfoLi">
								<div class="iconMeterDetail" style="background-color: #00CC66;">
									<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')"
										alt="" />
								</div>
								<div @change="changeBaseMoney()">
									<p>基本电费分摊值</p>
									<h2><span>{{item.basicElectricityCharges}}</span></h2>
								</div>
							</div>

							<div class="houseInfoLi">
								<div class="iconMeterDetail" style="background-color: #00CC66;">
									<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')"
										alt="" />
								</div>
								<div @change="changeBaseMoney()">
									<p>电表类型</p>
									<h2 v-show="item.meterRunType==1 || item.meterRunType=='' ">预付费表</h2>
									<h2><span v-show="item.meterRunType==2">远控表</span></h2>
								</div>
							</div>

							<div class="houseInfoLi">
								<div class="iconMeterDetail" style="background-color: #00CC66;">
									<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')"
										alt="" />
								</div>
								<div @change="changeBaseMoney()">
									<p>缴费类型</p>
									<h2 v-show="item.accountType==0 ">后付费</h2>
									<h2><span v-show="item.accountType==1">预付费</span></h2>

								</div>
							</div>

						</div>
						<div class="flexAround">

							<div class="houseInfoLi">
								<div class="iconMeterDetail" style="background-color: #66CCCC;">
									<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')"
										alt="" />
								</div>
								<p>关联业主</p>
								<h2><span>{{editText(item.userName)}}</span></h2>
							</div>

							<div class="houseInfoLi">
								<div class="iconMeterDetail" style="background-color: #FF9900;">
									<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')"
										alt="" />
								</div>
								<p>账户余额</p>
								<h2>
									<span class="warncolor" v-if="userBalance">{{MoneyText(userBalance)}}元</span>
									<span class="warncolor" v-else="userBalance">0元</span><br />
									<button class="operateBtn" @click="cashPayRecharge">充值</button>
								</h2>
							</div>


							<div class="houseInfoLi" v-if="item.accountType==1 && item.meterRunType==1">
								<div class="iconMeterDetail" style="background-color: #66CCCC;">
									<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')"
										alt="" />
								</div>
								<p>剩余电量</p>
								<h2><span>{{editText(remainingElectricity)}}</span></h2>
								<button class="operateBtn" @click="powerRecharge">充值</button>
							</div>

							<div class="houseInfoLi" v-else>
								<div class="iconMeterDetail" style="background-color: #66CCCC;">
									<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')"
										alt="" />
								</div>
								<p>缴费状态</p>
								<h2 v-if="payText(userBalance)>=0"><span>正常</span></h2>
								<h2 v-else><span style="color: red">欠费</span></h2>
								<!--							<button class="operateBtn" @click="cashPayRecharge">充值</button>-->
							</div>

							<div class="houseInfoLi">
								<div class="iconMeterDetail" style="background-color: #EC6868;">
									<img :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/meterOnline.png')"
										alt="" />
								</div>
								<p>电表状态</p>
								<h2>
									<img :src="getDeviceStateSource(item.state232)" alt="" />
									<br />
									<button v-show="parseInt(item.state232) == 1" class="operateBtn"
										@click="changeDeviceState(0)">关</button>
									<button v-show="parseInt(item.state232) != 1" class="operateBtn"
										@click="changeDeviceState(1)">开</button>
								</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="meterDetailCenter">
				<div class="areaContainer">
					<p class="areaTitle">抄表概况
						<!-- <button class="operateBtn" style="float: right;margin-top: 8px;">抄表</button> -->
					</p>
					<div class="areaContentHeight custom-scrollbar flexBetween" style="flex-wrap: wrap;">
						<div class="electricAnalyzeLi">
							<p>开始时间</p>
							<p>{{editText(item.minBeginTime)}} </p>
						</div>

						<div class="electricAnalyzeLi">
							<p>结束时间</p>
							<p>{{editText(item.maxEndTime)}}</p>
						</div>
						<div class="electricAnalyzeLi">
							<p>计费方式</p>
							<p>{{editText(item.billingMode)}}</p>
						</div>
						<div class="electricAnalyzeLi">
							<p>开始抄表电度</p>
							<p>{{payText(item.minBeginMeterReading)}}</p>
						</div>
						<div class="electricAnalyzeLi">
							<p>结束抄表电度</p>
							<p>{{payText(item.maxEndMeterReading)}}</p>
						</div>
						<div class="electricAnalyzeLi">
							<p>用电量</p>
							<!--							<p>{{editText(item.realElectricQuantity)}}</p>-->
							<p>{{editText(item.electricQuantity)}}</p>
						</div>
						<div class="electricAnalyzeLi">
							<p>免费额度</p>
							<p>{{payText(item.freeQuota)}}</p>
						</div>
						<div class="electricAnalyzeLi">
							<p>剩余免费额度</p>
							<p>{{payText(item.surplusQuota)}}</p>
						</div>

						<div class="electricAnalyzeLi">
							<p>累计费用</p>
							<p>{{MoneyText(item.userBalanceSum)}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="meterDetailRight">
				<div class="areaContainer">
					<div style="float: right;margin-top: 5px">
						<span class="selectDate" @click="$refs.datePicker.show()">{{nowSelectDate.formatByDate()}}<img
								:src="resourcesStore.getResourcesByName('/meterReading/icon_date.png')" alt="" /></span>
					</div>
					<p class="areaTitle">运行预警</p>
					<div v-show="eventsList.length == 0 " class="flexCenter areaContentHeight">
						<p class="notAvailableMessage">暂无预警信息</p>
					</div> 
					<ul class="custom-scrollbar" style="height: calc(100% - 48px);">
						<li class="messageLi" v-for="(e,index) in eventsList " :key="'warn'+index">
							<span class="messageAlert">{{e.typeName}}</span>
							{{e.deviceName}}&nbsp;{{e.time}}&nbsp;{{e.description}}
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="areaContainer" style="margin-top: 10px;height: calc(50% - 40px);width: 72.8%;float: left">
			<p class="areaTitle">用电信息 单位:(KWH)
			<div class="changeTypeAndTime">
				<span class="selectDate" @click="$refs.datePicker.show()">{{nowSelectDate.formatByDate()}}<img
						:src="resourcesStore.getResourcesByName('/meterReading/icon_date.png')" alt="" /></span>
				<div class="changeDateTypeBtns">
					<button v-for="item in timeTypeList" :class="{'nowDateTypeAct':nowTimeType == item.value}"
						@click="changeTimeType(item)">{{item.name}}</button>
				</div>
			</div>
			</p>
			<vchart class="areaContentHeight" ref='vchartBar'></vchart>
		</div>

		<div class="areaContainer" style="width: 26.5%;float: right;margin-top: 10px;height: calc(50% - 40px)">
			<div style="float: right;margin-top: 5px">
				<span class="selectDate" @click="$refs.datePicker.show()">{{nowSelectDate.formatByDate()}}<img
						:src="resourcesStore.getResourcesByName('/meterReading/icon_date.png')" alt="" /></span>
			</div>
			<p class="areaTitle">扣费信息</p>
			<div v-if="deductionList.length  ==0 ">
				<p class="notAvailableMessage">暂无扣费信息</p>
			</div>
			<ul v-else class="custom-scrollbar areaContentHeight">
				<li class="messageLi" v-for="item in deductionList">
					<span class="messageAlert">{{item.Time}}</span>
					<span class="payType">{{item.deviceName}}</span>
					<span>扣除电费{{MoneyText(item.amount)}}</span>元
				</li>
			</ul>
		</div>


		<VerifyPasswordDialog ref="verifyPasswordDialog"></VerifyPasswordDialog>
		<SetMultiplyingPowerDialog ref="setMultiplyingPowerDialog"></SetMultiplyingPowerDialog>
		<CashPayRechargeDialog ref="cashPayRechargeDialog"></CashPayRechargeDialog>
		<SelectChargeModeDialog ref="selectChargeModeDialog"></SelectChargeModeDialog>
		<EditChargeDateDialog ref="editChargeDateDialog"></EditChargeDateDialog>
	</div>
</template>

<script>
	import datePicker from '@/components/module/universal/datePicker.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import VerifyPasswordDialog from './dialogs/VerifyPasswordDialog.vue'
	import SetMultiplyingPowerDialog from './dialogs/SetMultiplyingPowerDialog.vue'
	import CashPayRechargeDialog from './dialogs/CashPayRechargeDialog.vue'
	import SelectChargeModeDialog from './dialogs/SelectChargeModeDialog.vue'
	import EditChargeDateDialog from './dialogs/EditChargeDateDialog.vue'
	import meterManagerStore from './meterManagerStore.js'
	export default {
		components: {
			datePicker,
			iconButton,
			VerifyPasswordDialog,
			SetMultiplyingPowerDialog,
			CashPayRechargeDialog,
			SelectChargeModeDialog,
			EditChargeDateDialog,
			vchart
		},
		props: {},
		data() {
			return {
				item: {
					"amountOfArrears": null,
					"freeQuota": 0,
					"meterReadingStatus": "ENABLE",
					"maxEndElectric": 278.7,
					"deductionStandard": null,
					"deviceName": "129",
					"lastDeductionFeeTime": null,
					"balance": 68493,
					"entityName": "MeterReadingConfig",
					"id": "142",
					"meterRunType": 2,
					"state": 1,
					"minBeginTime": "2023-10-31 17:00:34",
					"useElectric": "278.70",
					"accountType": "1",
					"userBingdingTime": 1698920442000,
					"balanceAlarm": 10000,
					"deviceNo": 142,
					"electricQuantity": 12.3,
					"generallyName": "129",
					"surplusQuota": null,
					"isAutomaticBrake": 1,
					"deviceState": 1,
					"cardNumber": null,
					"billingMode": "单价计费",
					"deviceAlias": null,
					"firstRealDeductionFeeTime": null,
					"bankName": null,
					"billingModePkid": 279341784350721,
					"realAmount": 0,
					"meterReadingStartTime": 1698742800000,
					"deductionFeeDay": 1,
					"sn": "202307130113",
					"basicElectricityCharges": 0,
					"amount": 984,
					"cardType": null,
					"maxEndTime": "2024-05-12 14:00:00",
					"minBeginMeterReading": 4140.6,
					"userName": "麦当劳",
					"userBalanceSum": 1231444.64,
					"conversionRate": null,
					"userId": "4831a8f321f8498487166c8202daeb87",
					"state232": null,
					"realElectricQuantity": 0,
					"createTime": 1693305021000,
					"meterType": "electric",
					"maxEndMeterReading": 18968.8,
					"realDeductionFeeTime": null,
					"minStartElectric": 0
				},
				baseMoney: 0,//基本电费分摊值
				deductionList: [{
					typeName:'设备故障',
					deviceName:'空调',
					Time:'2021-01-02',
					amount:10000,
				},{
					typeName:'设备故障',
					deviceName:'冰箱',
					Time:'2021-02-02',
					amount:10000,
				},{
					typeName:'设备故障',
					deviceName:'电灯',
					Time:'2021-01-03',
					amount:10000,
				},{
					typeName:'设备故障',
					deviceName:'空调',
					Time:'2021-03-04',
					amount:10000,
				},{
					typeName:'设备故障',
					deviceName:'冰箱',
					Time:'2021-04-02',
					amount:10000,
				},{
					typeName:'设备故障',
					deviceName:'电灯',
					Time:'2021-05-02',
					amount:10000,
				},{
					typeName:'设备故障',
					deviceName:'空调',
					Time:'2021-01-02',
					amount:10000,
				},{
					typeName:'设备故障',
					deviceName:'空调',
					Time:'2021-01-02',
					amount:10000,
				},],//扣费列表
				remainingElectricity: '',//剩余电量
				userBalance: '',//用户余额
				userDeviceInfo: [],
				deDataTime: '',//查询时间
				beginTime: '',//开始时间
				endTime: '',//结束时间
				// dueDateNum: 0,
				eventsList: [{
					typeName:'设备故障',
					deviceName:'空调',
					time:'2021-01-02',
					description:'设备运行故障',
				},{
					typeName:'设备故障',
					deviceName:'冰箱',
					time:'2021-02-02',
					description:'设备运行故障',
				},{
					typeName:'设备故障',
					deviceName:'空调',
					time:'2021-02-02',
					description:'设备运行故障',
				},{
					typeName:'设备故障',
					deviceName:'电灯',
					time:'2021-03-02',
					description:'设备运行故障',
				},{
					typeName:'设备故障',
					deviceName:'空调',
					time:'2021-03-03',
					description:'设备运行故障',
				},{
					typeName:'设备故障',
					deviceName:'空调',
					time:'2021-01-02',
					description:'设备运行故障',
				},{
					typeName:'设备故障',
					deviceName:'冰箱',
					time:'2021-01-02',
					description:'设备运行故障',
				},{
					typeName:'设备故障',
					deviceName:'空调',
					time:'2021-01-02',
					description:'设备运行故障',
				},{
					typeName:'设备故障',
					deviceName:'电灯',
					time:'2021-01-02',
					description:'设备运行故障',
				},{
					typeName:'设备故障',
					deviceName:'空调',
					time:'2021-01-02',
					description:'设备运行故障',
				}],//按时间查找告警记录
				options: {
					color: ['#3AA1FF'],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						data: []
					},
					grid: {
						top: 20,
						left: 15,
						right: 15,
						bottom: 10,
						containLabel: true
					},
					xAxis: [
						{
							type: 'category',
							axisTick: { alignWithLabel: true },
							splitLine: { show: false }
						}
					],
					yAxis: {
						axisLine: { show: false },
						axisTick: { show: false },
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#CCCCCC'
							}
						},
						type: 'value'
					},
					series: []
				},
				electricAnalyze: [{ name: "上次抄表度数", value: '-' }, { name: "本次抄表度数", value: '-' }, { name: "计费方式", value: '-' }, { name: "本月用量", value: '-' }, { name: "抄表日期", value: '-' }, { name: "消费金额", value: '-' }],
				nowTimeType: 'month',
				timeTypeList: [{ name: '日电量', value: 'day' }, { name: '周电量', value: 'week' }, { name: '月电量', value: 'month' }, { name: '季电量', value: 'quarter' }, { name: '年电量', value: 'year' }],
				fromName: {},
				dataObject: {
				"龙维4161-2号变压器输出(市电供).合相正向有功电能": [
					112,
					232,
					234,
					122,
					112,
					232,
					234,
					122,
					112,
					232,
					234,
					122,
					112,
					232,
					234,
					122,
					112,
					232,
					234,
					122,
					112,
					232,
					234,
					122,
					112,
					232,
					234,
					122,
					112,
					112,
					111
				],
					"summary": "0"
				},
			}
		},
		mounted() {
			this.$refs.vchartBar.setData(this.options, true);
			this.reloadChart(this.dataObject);
		},
		beforeDestroy() {
			removeTask('getDeviceEvents')
		},
		destroyed() { },
		computed: {
			getDeviceStateSource() {
				return state => {
					if (parseInt(state) == 1) {
						return this.$store.resourcesStore.getters.getResourcesByName('keli/state_on.png')
					} else if (parseInt(state) == 0) {
						return this.$store.resourcesStore.getters.getResourcesByName('keli/state_off.png')
					}
					return this.$store.resourcesStore.getters.getResourcesByName('keli/state_no.png')
				}
			},
			resourcesStore() {
				return this.$store.resourcesStore.getters
			},
			nowSelectDate() {
				return this.$store.cacheStore.getters.getNowSelectDate
			},
			editText() {
				return text => {
					return text == null || text == '' || text == undefined ? '-' : text
				}
			},

			//返回0
			payText() {
				return text => {
					return text == null || text == '' || text == undefined ? 0 : text
				}
			},

			//金额处理 除以100
			MoneyText() {
				//debugger
				return text => {
					return text == null || text == '' || text == undefined ? 0 : cutDigital(text / 100, 2)
				}
			},

			event() {
				//console.info("temp:"+new Date());
				this.eventsList = meterManagerStore.getters.getDeviceEvent.data;
				console.log("预警信息5465", this.eventsList);
				return meterManagerStore.getters.getDeviceEvent
			},
			//充值记录
			payRecords() {
				return meterManagerStore.getters.getDevicePayRecords
			},
			showPayRecord() {
				return isempty(this.payRecordList) ? false : true
			},
			getPayTime() {
				return bill => {
					return new Date(bill.createTime).formatByTime()
				}
			},
			getPayNum() {
				return bill => {
					return bill.amount / 100
				}
			},
			getPayType() {
				return bill => {
					switch (bill.detailType) {
						case 'Recharge_AliPay':
							return '支付宝'
						case 'Recharge_CashPay':
							return '现金支付'
						case 'Recharge_UnionPay':
							return '银行卡'
						case 'Recharge_WeixinPay':
							return '微信'
					}
				}
			},
			variableTree() {
				if (isempty(this.item)) {
					return []
				}
				return this.$store.variableStore.getters.getVariableTree(this.item.deviceNo)
			},
			variableNames() {
				// 所有的通讯变量名称
				var list = []
				for (var i = 0, len = this.variableTree.length; i < len; i++) {
					if (this.variableTree[i].no == 3) {
						var next = this.variableTree[i].next
						for (var i2 = 0, len2 = next.length; i2 < len2; i2++) {
							var item = next[i2]
							this.fromName[item.fromName] = item.name
							list.push(item.fromName)
						}
					}
				}
				return list
			},
		},
		watch: {
			variableNames(nv, ov) {
				this.reloadChart(this.dataObject)	 
				// this.getDeductionList()
			},
			dataObject(nv, ov) {
				this.reloadChart(nv)
			},
		},
		methods: {
			//lxk 时间类型排序
			sort(value) {
				return function (a, b) {
					//debugger
					var s1 = a[value];
					var s2 = b[value];
					return s1 < s2 ? 1 : -1
				}
			},
			//根据时间查询消费记录
			deductionTimeChange() {
				// console.log("查询方法");
				this.beginTime = this.nowSelectDate.getTime();
				this.endTime = this.nowSelectDate.getTime() + 3600000 * 24 - 1000;//XXXX:XX:XX 23:59:59
				this.$api.meterReadingApi.getElectricityBill(this.item.userId, this.item.meterType, null, 1, 20, this.item.deviceNo, null, null, this.beginTime, this.endTime, this.item.accountType, this.item.meterRunType, respon => {
					this.deductionList = copy(respon.dataList.sort(this.sort('createTime')))
					// console.log("getDeductionList",this.deductionList);
					for (var i = 0; i < respon.dataList.length; i++) {
						this.deductionList[i]['Time'] = new Date(respon.dataList[i].beginTime).formatByTime() + ' - ' + new Date(respon.dataList[i].endTime).formatByTime();
					}
				})

			},

			//根据时间、设备号  查找设备告警列表
			getEventsByTimeAndDeviceNo() {
	 
				this.beginTime = this.nowSelectDate.getTime();
				this.endTime = this.nowSelectDate.getTime() + 3600000 * 24 - 1000;//XXXX:XX:XX 23:59:59
				this.$api.eventApi.searchEventListByUser(this.item.userId, null, '', -1, '', this.item.deviceNo, this.beginTime, this.endTime, 1, 100, '',
					respon => {
						this.eventsList = copy(respon.data.sort(this.sort('time')));
					 
					})
			},

			//扣费记录
			getDeductionList() {
				this.$api.meterReadingApi.getElectricityBill(this.item.userId, this.item.meterType, null, 1, 20, this.item.deviceNo, null, null, null, null, this.item.accountType, this.item.meterRunType, respon => {
					this.deductionList = copy(respon.dataList.sort(this.sort('createTime')))
					console.log("扣费", this.item);
					for (var i = 0; i < respon.dataList.length; i++) {
						this.deductionList[i]['Time'] = new Date(respon.dataList[i].beginTime).formatByTime() + ' - ' + new Date(respon.dataList[i].endTime).formatByTime();
					}
				})
			},

			timeText() {
				//debugger
				return time => {
			 
					return new Date(time).formatByTime()
				}
			},

			selectDate(date) {
				this.$store.cacheStore.commit("setNowSelectDate", date)
				this.$refs.datePicker.hide()
				this.reloadChart(this.dataObject)	 
				this.deductionTimeChange();
				this.getEventsByTimeAndDeviceNo();
				// this.getDeductionList()
			},
			closeDetails() {
				this.$emit('closeDetails')
			},
			setItem(item) {
				// console.log("设置item",item);
				this.item = item
				this.remainingElectricity = this.item.remainingElectricity;
				this.userBalance = this.item.balance;
				this.electricAnalyze[0].value = item.beginMeterReading
				this.electricAnalyze[1].value = item.endMeterReading
				this.electricAnalyze[5].value = item.amount / 100 + '元'
				switch (item.billingMode) {
					case 'StepBilling':
						this.electricAnalyze[2].value = '阶梯计费'
						break
					case 'PeakAndValleyBilling':
						this.electricAnalyze[2].value = '费率计费'
						break
					case 'SingleBilling':
						this.electricAnalyze[2].value = '单价计费'
						break
				}
				if (item.endMeterReading == undefined || isempty(item.endMeterReading) || item.beginMeterReading == undefined || isempty(item.beginMeterReading)) {
					this.electricAnalyze[3].value = '-'
				} else {
					this.electricAnalyze[3].value = (item.endMeterReading - item.beginMeterReading).toFixed(1)
				}
				this.electricAnalyze[4].value = isempty(item.lastDeductionFeeTime) ? '-' : new Date(item.lastDeductionFeeTime).formatByDate()
				this.getEventsByTimeAndDeviceNo()
				this.deductionTimeChange()
			},
			// 充值
			cashPayRecharge() {

				this.getUserDeviceList();
				this.$refs.cashPayRechargeDialog.open(this.userDeviceInfo, this.item.balance, (password, chargeNum, deviceNo, conversionRate) => {
					this.$api.payApi.cashPayRecharge(this.item.userId, 'MeterReading', chargeNum * 100, password, deviceNo, conversionRate, respon => {
						console.info("cashPayRecharge,response:" + JSON.stringify(respon));
						this.$dialogMethod.showMessage(respon.msg.toString())
						this.userBalance = respon.userBalance;
						this.remainingElectricity = respon.newElectricity;
					}, err => {
						this.$dialogMethod.showMessage(err)
					})
				})
			},

			//充电量
			powerRecharge() {
				this.getUserDeviceList();
				this.$refs.cashPayRechargeDialog.open(this.userDeviceInfo, this.item.balance, (password, chargeNum, deviceNo, conversionRate) => {
					this.$api.payApi.powerRecharge(this.item.userId, 'MeterReading', chargeNum * 100, password, deviceNo, conversionRate, respon => {
						this.$dialogMethod.showMessage(respon.msg.toString())
						console.info("powerRecharge,response:" + JSON.stringify(respon));
						this.userBalance = respon.userBalance;
						this.remainingElectricity = respon.newElectricity;

					}, err => {
						this.$dialogMethod.showMessage(err)
					})
				})

			},

			//业主设备列表
			async getUserDeviceList() {
				this.$api.meterReadingApi.getUserDeviceList(this.item.userId, respon => {
					this.userDeviceInfo = respon;
				})
			},

			// 修改缴费日期
			editChargeDate() {
				this.$refs.editChargeDateDialog.open('修改抄表日期', this.item.deductionFeeDay, result => {
					this.$api.meterReadingApi.updateDeductionFeeDay(this.item.deviceNo, result.deductionFeeDay, result.password, respon => {
						this.item.deductionFeeDay = result.deductionFeeDay
						this.$dialogMethod.showMessage('修改缴费日期成功')
					}, err => {
						this.$dialogMethod.showMessage(err)
					})
				})
			},

			//用户 余额
			getUserBalance() {
				this.$api.balanceApi.searchBalance(this.nowOwnerInformation.userId, "MeterReading", respon => {
					this.nowOwnerInformation.balance = respon.balance;
				})
			},

			// 发送催缴信息
			sendCallForMeter() {
				this.$refs.verifyPasswordDialog.open('密码验证', password => {
					this.$api.meterReadingApi.sendCallForMeter(this.item.ownerId, this.item.deviceNo, password, respon => {
						this.$dialogMethod.showMessage('发送催缴短信成功')
					}, err => {
						this.$dialogMethod.showMessage(err)
					})
				})
			},
			// 合闸、断闸
			changeDeviceState(state) {
				this.$refs.verifyPasswordDialog.open('密码验证', password => {
					this.$api.meterReadingApi.controlMeter(this.item.userId, this.item.deviceNo, state, password, respon => {
						this.item.state232 = state
						this.$dialogMethod.showMessage('操作成功')
					}, err => {
						this.$dialogMethod.showMessage(err)
					})
				})
			},

			// 更改基本电费分摊值
			changeBaseMoney() {
				this.$api.meterReadingApi.changeBaseMoney(this.item.deviceNo, this.item.basicElectricityCharges, respon => {
					this.$dialogMethod.showMessage('修改基本电费分摊值成功')
				}, err => {
					this.$dialogMethod.showMessage(err)
				})
			},


			// 修改电表倍率、计费方式
			changeDeviceSet(set) {
				if (set.name == '电表倍率') {
					this.$refs.setMultiplyingPowerDialog.open(this.item.magnification, result => {
						if (this.item.magnification == result.magnification) {
							this.$dialogMethod.showMessage('新设倍率与当前电表倍率一致无需修改')
							return
						}
						this.$api.meterReadingApi.updateMeterMagnification(this.item.deviceNo, result.magnification, result.password, respon => {
							this.$dialogMethod.showMessage('设置电表倍率成功')
							this.item.magnification = respon.magnification
							this.setItem(this.item)
						}, err => {
							this.$dialogMethod.showMessage(err)
						})
					})
				} else if (set.name == '计费方式') {
					this.$refs.selectChargeModeDialog.open(this.item, result => {
						this.$api.meterReadingApi.updateMeterBillingMode(this.item.deviceNo, result.pkid, result.password, respon => {
							this.$dialogMethod.showMessage('设置计费方式成功')
							this.item.billingMode = result.billingMode
							this.item.billingModePkid = result.pkid
							this.setItem(this.item)
						}, err => {
							this.$dialogMethod.showMessage(err)
						})
					})
				}
				return
			},
			changeTimeType(item) {
				this.nowTimeType = item.value
				// 数据展示类型切换重新获取数据
				this.reloadChart(this.dataObject)	 
			},
			getVchartDatas(variableNames) {
				if (isempty(variableNames)) {
					return
				}
		 
			},
			reloadChart(list) {
				if (isempty(list)) {
					return
				}
				switch (this.nowTimeType) {
					case 'day':
						var keys = Object.keys(list)
						var dataList = list[keys[0]]
						var seriesList = []
						var name = this.fromName[keys[0]] ? this.fromName[keys[0]] : keys[0]
						name = name.subByFirstChar(".")
						var vlist = []
						//取整点值
						for (var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							if (isNaN(parseFloat((item))) || isnull(parseFloat((item)))) {
								item = undefined
							}
							var label = (i < 10 ? "0" : '') + i + ":00"
							vlist.push([label, item])
						}
						seriesList.push({
							name: name,
							type: 'bar',
							data: vlist
						})
						break
					case 'week':
						var keys = Object.keys(list)
						var dataList = list[keys[0]]
						var seriesList = []
						var weekList = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
						var name = this.fromName[keys[0]] ? this.fromName[keys[0]] : keys[0]
						name = name.subByFirstChar(".")
						var vList = []
						for (var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							if (isNaN(parseFloat((item))) || isnull(parseFloat((item)))) {
								item = undefined
							}
							vList.push([weekList[i], item])
						}
						seriesList.push({
							name: name,
							type: 'bar',
							data: vList
						})
						break
					case 'month':
						var keys = Object.keys(list)
						var seriesList = []
						var dataList = list[keys[0]]
						var name = this.fromName[keys[0]] ? this.fromName[keys[0]] : keys[0]
						name = name.subByFirstChar(".")
						var vlist = []
						for (var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							if (isNaN(parseFloat((item))) || isnull(parseFloat((item)))) {
								item = undefined
							}
							vlist.push([(i + 1) + '日', item])
						}
						seriesList.push({
							name: name,
							type: 'bar',
							data: vlist,
						})
						break
					case 'quarter':
						var keys = Object.keys(list)
						var dataList = list[keys[0]]
						var seriesList = []
						var quarter = parseInt((this.nowSelectDate.getMonth() + 3) / 3)
						var Month = [
							["一月", "二月", "三月"],
							["四月", "五月", "六月"],
							["七月", "八月", "九月"],
							["十月", "十一月", "十二月"]
						]
						var quarterList = Month[quarter - 1]
						var name = this.fromName[keys[0]] ? this.fromName[keys[0]] : keys[0]
						name = name.subByFirstChar(".")
						var vList = []
						for (var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							if (isNaN(parseFloat((item))) || isnull(parseFloat((item)))) {
								item = undefined
							}
							vList.push([quarterList[i], item])
						}
						seriesList.push({
							name: name,
							type: 'bar',
							data: vList
						})
						break
					case 'year':
						var keys = Object.keys(list)
						var dataList = list[keys[0]]
						var seriesList = []
						var name = this.fromName[keys[0]] ? this.fromName[keys[0]] : keys[0]
						name = name.subByFirstChar(".")
						var vList = []
						for (var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							if (isNaN(parseFloat((item))) || isnull(parseFloat((item)))) {
								item = undefined
							}
							vList.push([(i + 1) + '月', item])
						}
						seriesList.push({
							name: name,
							type: 'bar',
							data: vList
						})
						break
				}
				this.options.series = seriesList
				this.$refs.vchartBar.setData(this.options, true)
			}
		}
	}
</script>

<style scoped>
	.detailsTop {
		margin-bottom: 10px;
	}

	.meterDetailLeft {
		width: calc(46% - 5px);
		height: 100%;
	}

	.meterDetailCenter {
		width: calc(27% - 7.5px);
		height: 100%;
	}

	.meterDetailRight {
		width: calc(27% - 7.5px);
		height: 100%;
	}

	.meterDetailLeft>.areaContainer {
		height: 100%;
	}

	.meterDetailCenter>.areaContainer {
		height: 100%;
	}

	.meterDetailRight>.areaContainer {
		height: calc(100% - 5px);
	}

	.meterDetailRight>.areaContainer:first-child {
		margin-bottom: 10px;
	}

	.areaContainer {
		padding: 0 10px 10px 10px;
		background: #FFFFFF;
		box-sizing: border-box;
		border: solid 1px #E4E4E4;
	}

	.areaTitle {
		font-size: .16rem;
		font-weight: bold;
		line-height: 48px;
	}

	.areaContentHeight {
		height: calc(100% - 48px) !important;
	}

	.ownerAddress {
		color: #999999;
		font-size: .12rem;
		margin-left: 30px;
	}

	.houseInfoLi {
		width: 140px;
		text-align: center;
	}

	.houseInfoLi>p {
		margin-bottom: 8px;
	}

	.houseInfoLi>p:nth-of-type(2) {
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.houseInfoLi>p:nth-of-type(2)>span {
		font-weight: bold;
		font-size: .16rem;
	}

	.houseInfoLi>p:nth-of-type(2)>span:first-child {
		display: block;
	}

	.houseInfoLi>p:nth-of-type(2)>.dueDate {
		display: inline-block;
		width: auto;
		padding: 0 10px;
		border-radius: 9px;
		line-height: 18px;
		font-size: .12rem;
		color: #FFFFFF;
		background-color: #F56C6C;
		margin-top: 6px;
	}

	.houseInfoLi>p:nth-of-type(2)>.ownerInfoStatus {
		color: #0099FF;
	}

	.operateBtn {
		height: 30px;
		padding: 0 8px;
		border: solid 1px #0099FF;
		color: #0099FF;
		border-radius: 4px;
		margin-top: 4px;
		background-color: #ECF5FF;
		cursor: pointer;
		outline: none;
	}

	.warncolor {
		color: #FF9900;
	}

	.iconMeterDetail {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: 60px;
		height: 60px;
		border-radius: 50%;
		margin-bottom: 10px;
	}

	.iconMeterDetail>img {
		transform: scale(0.6);
	}

	.messageLi {
		padding: 2px 8px;
		border: solid 1px #F2F2F2;
		margin-bottom: 6px;
		font-size: .12rem;
	}

	.messageLi>span {
		font-size: .12rem;
	}

	.messageLi:last-child {
		margin-bottom: 0;
	}

	.messageAlert {
		display: inline-block;
		height: 18px;
		border: solid 1px #FF9900;
		border-radius: 4px;
		padding: 0 4px;
		font-size: .12rem;
		color: #FF9900;
		margin-right: 4px;
	}

	.payType {
		color: #409EFF;
	}

	.electricAnalyzeLi {
		width: calc(50% - 20px);
		border: solid 1px #E4E4E4;
		text-align: center;
		border-top-left-radius: 6px;
		border-top-right-radius: 6px;
		overflow: hidden;
		margin-top: 3px;
	}

	.electricAnalyzeLi:last-child {
		width: 100%;
	}

	.electricAnalyzeLi>p:first-child {
		background: #409EFF;
		line-height: 32px;
		color: #FFFFFF;
	}

	.electricAnalyzeLi>p:last-child {
		line-height: 40px;
		font-weight: bold;
	}

	.electricAnalyzeLi>p>img {
		margin-left: 8px;
		cursor: pointer;
	}

	.notAvailableMessage {
		border: solid 1px #E4E4E4;
		padding: 4px 50px;
		color: #CACACA;
	}

	.changeTypeAndTime {
		float: right;
		margin-top: -40px;
	}

	.selectDate {
		display: inline-block;
		margin-right: 20px;
		border: solid 1px #E4E4E4;
		border-radius: 4px;
		line-height: 34px;
		vertical-align: top;
		width: 120px;
		padding: 0 10px;
		font-weight: bold;
		color: #C0C4CC;
	}

	.selectDate>img {
		float: right;
		width: 17px;
		height: 19px;
		margin: 7px 0;
	}

	.changeDateTypeBtns {
		display: inline-block;
		border: solid 1px #409EFF;
		border-radius: 4px;
		overflow: hidden;
	}

	.changeDateTypeBtns>button {
		background: #ECF5FF;
		color: #409EFF;
		height: 32px;
		padding: 0 8px;
		cursor: pointer;
		border-right: solid 1px #409EFF;
		outline: none;
	}

	.changeDateTypeBtns>button:last-child {
		border: none;
	}

	.changeDateTypeBtns>.nowDateTypeAct {
		background: #409EFF;
		color: #FFFFFF;
	}

	@media screen and (max-width: 1600px) {
		.houseInfoLi>p {
			font-size: .12rem;
			margin-bottom: 6px;
		}

		.houseInfoLi>p:nth-of-type(2)>span {
			font-size: .14rem;
		}

		.houseInfoLi>p:nth-of-type(2)>span:first-child {
			display: block;
		}

		.iconMeterDetail {
			width: 40px;
			height: 40px;
			margin-bottom: 6px;
		}

		.iconMeterDetail>img {
			transform: scale(0.4);
		}

		.operateBtn {
			height: 28px;
			padding: 0 6px;
		}

		.ownerInfoStatus {
			font-size: .14rem;
		}

		.electricAnalyzeLi {
			margin-bottom: 10px;
		}

		.electricAnalyzeLi>p:first-child {
			line-height: 22px;
		}

		.electricAnalyzeLi>p:last-child {
			line-height: 28px;
		}
	}

	@media screen and (max-width: 1400px) {
		.houseInfoLi>p {
			font-size: .12rem;
			margin-bottom: 2px;
		}

		.houseInfoLi>p:nth-of-type(2)>span {
			font-size: .14rem;
		}

		.houseInfoLi>p:nth-of-type(2)>span:first-child {
			display: block;
		}

		.iconMeterDetail {
			width: 40px;
			height: 40px;
			margin-bottom: 2px;
		}

		.iconMeterDetail>img {
			transform: scale(0.4);
		}

		.operateBtn {
			height: 20px;
			padding: 0 6px;
			font-size: .12rem;
		}

		.ownerInfoStatus {
			font-size: .14rem;
		}

		.electricAnalyzeLi {
			margin-bottom: 5px;
		}

		.electricAnalyzeLi>p:first-child {
			line-height: 22px;
		}

		.electricAnalyzeLi>p:last-child {
			line-height: 24px;
		}

		.areaTitle {
			font-size: .14rem;
			font-weight: bold;
			line-height: 30px;
		}

		.areaContentHeight {
			height: calc(100% - 30px) !important;
		}

		.selectDate {
			margin-right: 10px;
			border-radius: 2px;
			line-height: 24px;
			vertical-align: top;
			width: 100px;
			padding: 0 5px;
		}

		.selectDate>img {
			margin: 2px 0;
		}

		.changeDateTypeBtns {
			border-radius: 2px;
		}

		.changeDateTypeBtns>button {
			height: 24px;
			padding: 0 4px;
			font-size: .12rem;
		}
	}
</style>